import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Checkbox } from 'antd';
import jfCode from '../../imgs/jfCode.jpg';

const WarmTip = props => {
  const clickCheck = val => {
    const { nickName } = props.userInfo;
    const tipsVisible = JSON.parse(localStorage.getItem('tipsVisible'));
    let storeMap = tipsVisible ? tipsVisible : [];
    let obj = { name: nickName, tipsVisible: !val.target.checked };
    storeMap.forEach(item => {
      if (item.name === nickName) item.tipsVisible = !val.target.checked;
    });
    storeMap.push(obj);
    storeMap = props.arrUnique(storeMap, 'name');
    localStorage.setItem('tipsVisible', JSON.stringify(storeMap));
  };

  return (
    <Modal
      title="温馨提示"
      centered
      visible={props.visible}
      onCancel={props.onCancel}
      destroyOnClose={true}
      width={600}
      className="help-dialog"
      footer={null}
    >
      <div className="tipBox">
        <p>
          <b>
            为了更好的服务用户，2021年2月1日起，产品售后问题请添加九峰医疗售后微信号，谢谢
          </b>
        </p>
        <div className="tip-img">
          <img alt="" src={jfCode} />
          <p>扫一扫</p>
        </div>
        <div className="tip-checkbox">
          <Checkbox onChange={clickCheck}>不再提醒</Checkbox>
        </div>
      </div>
    </Modal>
  );
};
WarmTip.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  notice: PropTypes.object,
  userInfo: PropTypes.object,
  arrUnique: PropTypes.func,
};
export default WarmTip;
